/*
|--------------------------------------------------------------------------
| Wellgard Recommendation Renderer
|--------------------------------------------------------------------------
| render-results.js
|
| Part 1:
| - Product loading
| - Cache
| - Render engine
| - Product state
|--------------------------------------------------------------------------
*/

window.Wellgard = window.Wellgard || {};
window.Wellgard.octaneResultReceived = false;

(function () {


    /*
    |--------------------------------------------------------------------------
    | CONFIG
    |--------------------------------------------------------------------------
    */

    const CONFIG = {

        containerId: "wellgard-results",

        productCacheEnabled: true,

        debug: true

    };


    /*
    |--------------------------------------------------------------------------
    | CACHE
    |--------------------------------------------------------------------------
    */

    const productCache = {};


    /*
    |--------------------------------------------------------------------------
    | PUBLIC API
    |--------------------------------------------------------------------------
    */


    window.Wellgard.Renderer = {


        render: render,


        clearCache:function(){

            Object.keys(productCache)
                .forEach(key=>{
                    delete productCache[key];
                });


            console.log(
                "Wellgard product cache cleared"
            );

        },


        destroy:function(){

            const container =
                document.getElementById(
                    CONFIG.containerId
                );


            if(container){

                container.innerHTML = "";

            }

        }


    };



    /*
    |--------------------------------------------------------------------------
    | MAIN RENDER FUNCTION
    |--------------------------------------------------------------------------
    */


    async function render(result){
        const container = getContainer();
        container.innerHTML = "";
       

        if(
        !result ||
        !result.recommendations ||
        result.recommendations.length === 0
        ){

            if(!window.Wellgard.octaneResultReceived){

                console.log(
                    "Waiting for Octane result..."
                );

                return;
            }


            showEmpty(container);
            return;
        }



        container.setAttribute("aria-busy", "true");

        try{
            const products =
                await loadProducts(
                    result.recommendations
                );

            container.innerHTML = "";
           
            products.forEach(product=>{
                const recommendation = result.recommendations.find(item=>{
                        return (
                            item.handle ===
                            product.handle
                        );
                    });


                if(!recommendation){
                    return;
                }

                const card =
                    createCard(
                        product,
                        recommendation
                    );



                container.appendChild(card);


            });

        // Show couppon section
        const targetDiv = document.getElementById('coupponCode');
        targetDiv.style.display = 'block';




        setTimeout(()=>{
            refreshYotpoWithRetry();
        },500);

        container.removeAttribute("aria-busy");



        const container_sec = document.getElementById("add-all-result");
        container_sec.style.backgroundColor = "#ffd602";
        container_sec.style.padding = "0px 0px 40px 40px";
       

        const addAllBtn = document.createElement("button");
        addAllBtn.textContent = "Add All to Cart";
        addAllBtn.className = "wg-add-all-cart";

        container_sec.appendChild(addAllBtn);

        addAllBtn.addEventListener("click", async () => {

            const cards = container.querySelectorAll(".wg-product-card");

            const items = [];

            cards.forEach(card => {

                const state = card.wellgardState;

                if(!state) return;

                const item = {
                    id: state.variantId,
                    quantity: state.quantity
                };

                if(state.sellingPlanId){
                    item.selling_plan = state.sellingPlanId;
                }

                items.push(item);
            });

            if(items.length === 0){
                alert("No products to add");
                return;
            }

            try{
                const response = await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ items })
                });

                const data = await response.json();

                console.log("Added all items:", data);

                

            }catch(err){
                console.error(err);
                alert("Failed to add products to cart.");
            }

        });



        trackEvent(
            "recommendations_viewed",
            {
                products:
                result.recommendations.map(item=>({

                    id:item.id,

                    handle:item.handle,

                    score:item.score

                }))
            }
        );



        }
        catch(error){


            console.error(
                "Wellgard Renderer Error",
                error
            );


            showError(container);


        }

        
    }





    /*
    |--------------------------------------------------------------------------
    | PRODUCT LOADING
    |--------------------------------------------------------------------------
    */


    async function loadProducts(
        recommendations
    ){


        const requests =
            recommendations.map(item=>{


                return fetchProduct(
                    item.handle
                );


            });



        const products =
            await Promise.all(
                requests
            );



        return products.filter(Boolean);


    }






    async function fetchProduct(handle){



        if(
            CONFIG.productCacheEnabled &&
            productCache[handle]
        ){

            if(CONFIG.debug){

                console.log(
                    "Cache:",
                    handle
                );

            }


            return productCache[handle];

        }





        const response =
            await fetch(
                `/products/${handle}.js`
            );



        if(!response.ok){


            throw new Error(
                `Product not found: ${handle}`
            );


        }





        const product =
            await response.json();




        if(
            CONFIG.productCacheEnabled
        ){

            productCache[handle] =
                product;

        }





        return product;


    }





    /*
    |--------------------------------------------------------------------------
    | CONTAINER
    |--------------------------------------------------------------------------
    */


    function getContainer(){


        let container =  document.getElementById(CONFIG.containerId );



        if(!container){
            container = document.createElement(
                    "div"
                );


            container.id =  CONFIG.containerId;



            document.body.appendChild(
                container
            );


        }   
        // Add Wellgard Results Styling
        container.style.backgroundColor = "#ffd602";

        container.style.padding = "80px 40px 40px";
        return container;


    }





    /*
    |--------------------------------------------------------------------------
    | PRODUCT CARD BASE
    |--------------------------------------------------------------------------
    */


    function createCard( product, recommendation){
        const card = document.createElement("div");
        card.className = "wg-product-card";
        card.addEventListener(
            "click",
            function(){
                trackEvent(
                    "recommendation_clicked",
                    {
                        product_id:
                            recommendation.id,
                        score:
                            recommendation.score
                    }
                );
            }
        );


        /*
        Product state
        */
        card.wellgardState = {
            productId:  product.id,
            productHandle:  product.handle,
            variantId: product.variants[0].id,
            sellingPlanId: null,
            quantity: 1    
        };
        const state = card.wellgardState;

        /*
        Product Image
        */
        const imageLink = document.createElement("a");
        imageLink.href = `/products/${product.handle}`;
        imageLink.className = "wg-product-image-link";

        const image = document.createElement("img");
        image.className = "wg-product-image";
        image.src = product.featured_image;
        image.alt = product.title;

        imageLink.appendChild(image);

        /*
        Title
        */
        const title = document.createElement("h3");

        const titleLink = document.createElement("a");

        titleLink.href = `/products/${product.handle}`;
        titleLink.target = "_blank";

        titleLink.textContent = product.title;

        titleLink.className = "wg-product-title-link";

        title.appendChild(titleLink);

        const benefit = document.createElement("div");

        benefit.className =  "wg-cross-sell-benefit";
        getCrossSellBenefit(product.id)
        .then(value=>{
            if(value){
                benefit.textContent =  '✓ ' + value;
                card.insertBefore(
                    benefit,
                    price
                );
            }
         });


        /*
        Score / Reason
        */
        const reasons = document.createElement("div");
        reasons.className = "wg-reasons";
        reasons.innerHTML = recommendation.reasons?recommendation.reasons.join("<br>") :  "";


        /*
        Price
        */
        const price = document.createElement("div");
        price.className = "wg-price";
        updatePrice( price,product.variants[0] );

        /*
        Variant selector
        */
        const variants = createVariantSelector(
                product,
                state,
                image,
                price
            );



        /*
        Subscription selector
        */
        const purchaseOptions =
            createPurchaseOptions(
                product,
                state,
                price
            );

        const quantity = createQuantitySelector(state);
        const addButton = createAddToCartButton(state);

        const yotpoStarDiv =
        document.createElement("div");


        yotpoStarDiv.className =
        "yotpo-widget-instance yotopwidget_custom";


        yotpoStarDiv.setAttribute(
            "data-yotpo-instance-id",
            "1225090"
        );


        yotpoStarDiv.setAttribute(
            "data-yotpo-product-id",
            product.id
        );


        yotpoStarDiv.setAttribute(
            "data-yotpo-cart-product-id",
            ""
        );


        yotpoStarDiv.setAttribute(
            "data-yotpo-section-id",
            "product"
        );


        yotpoStarDiv.setAttribute(
            "data-yotpo-preloaded-data",
            ""
        );
                
        /*
        Build Card
        */
        card.append(imageLink,title,yotpoStarDiv, price, variants, purchaseOptions, quantity, addButton, reasons  );

        


        return card;
    }


function refreshYotpo(){

    const event = new CustomEvent(
        "yotpo-widget-loaded"
    );

    document.dispatchEvent(event);


    console.log(
        "Yotpo refresh event sent"
    );

}



/*
|--------------------------------------------------------------------------
| Variant Selector
|--------------------------------------------------------------------------
*/


function createVariantSelector(  product,
    state,
    image,
    price
){


    const wrapper =
        document.createElement(
            "div"
        );


    wrapper.className =
        "wg-variants";



    if(product.variants.length <= 1){

        return wrapper;

    }





    product.variants.forEach(
        variant=>{


            const button =
                document.createElement(
                    "button"
                );



            button.type =
                "button";



            button.className =
                "wg-variant";



            button.textContent =
                variant.title;


            button.setAttribute(
                "aria-label",
                `Select ${variant.title}`
            );

            button.setAttribute(
                "aria-label",
                "Add product to cart"
            );



            if(
                variant.id ===
                state.variantId
            ){

                button.classList.add(
                    "active"
                );

            }





            button.onclick =
                function(){



                    state.variantId =
                        variant.id;



                    wrapper
                    .querySelectorAll(
                        ".wg-variant"
                    )
                    .forEach(btn=>{

                        btn.classList.remove(
                            "active"
                        );

                    });



                    button.classList.add(
                        "active"
                    );




                    updatePrice(
                        price,
                        variant
                    );

                    if(state.sellingPlanId){

                    const selectedPlan =
                        product.selling_plan_groups
                        ?.flatMap(group => group.selling_plans)
                        .find(plan =>
                            String(plan.id) ===
                            String(state.sellingPlanId)
                        );


                    if(selectedPlan){

                        const subscriptionPrice =
                            getSubscriptionPrice(
                                variant,
                                selectedPlan
                            );


                        updatePrice(
                            price,
                            {
                                price: subscriptionPrice
                            }
                        );

                    }

                }





                    if(
                        variant.featured_image
                    ){

                        image.src =
                            variant.featured_image.src;

                    }


                };



            wrapper.appendChild(
                button
            );


        }
    );



    return wrapper;


}






/*
|--------------------------------------------------------------------------
| Subscription Options
|--------------------------------------------------------------------------
*/


function createPurchaseOptions( product, state, priceElement){

    const wrapper =  document.createElement("div");
    wrapper.className ="wg-purchase-options"; 



    /*
    Subscription wrapper
    */

    const subscriptionBox =  document.createElement("div");
    subscriptionBox.className = "wg-subscription-box";

    /*
    One time option
    */

    const oneTime =
    createRadioOption(
        "One-Time Purchase",
        null,
        state,
        priceElement,
        subscriptionBox,
        product
    );


    const subscriptionRadio =
        createRadioOption(
            "Subscribe & Save 15%",
            "subscription",
            state,
            priceElement,
            subscriptionBox,
            product
        );


    const oneTime_selector =  document.createElement("div");
    oneTime_selector.className ="radio-box wg-rc-radio";     
    oneTime_selector.appendChild( oneTime );
    wrapper.appendChild(oneTime_selector);


    // wrapper.appendChild(
    //     subscriptionRadio
    // );

    const sub_selector =  document.createElement("div");
    sub_selector.className ="radio-box wg-rc-radio-sub";     
    sub_selector.appendChild( subscriptionRadio );
    wrapper.appendChild(sub_selector);



    /*
    Subscription plans
    */

    if(
        product.selling_plan_groups
    ){


        

        const subsave_enefits = document.createElement("div");

        subsave_enefits.className = "wg-subscription-title";

        // Use innerHTML instead of textContent
        subsave_enefits.innerHTML = `
            <p><strong>Save 15% today &amp; on every order<br>No code needed</strong>
            Easily pause, skip or cancel anytime.</p>
            <ul>
                <li>Free gifts on your 2nd, 4th, and 6th orders</li>
                <li>Cancel anytime (no fees)</li>
                <li>Skip a delivery in 1 click</li>
                <li>Swap products anytime</li>
            </ul>
        `;

        subscriptionBox.appendChild(subsave_enefits);



        /*
        Subscription dropdown
        */

        const deliverySelect =document.createElement("select");
        deliverySelect.className = "wg-delivery-select";       


        if(product.selling_plan_groups){
            product.selling_plan_groups
            .forEach(group=>{


                group.selling_plans
                .forEach(plan=>{
                    const option = document.createElement("option");
                    option.value =  plan.id;
                    option.dataset.plan = JSON.stringify(plan);
                    option.textContent = plan.name;



                    deliverySelect.appendChild(
                        option
                    );


                });


            });


        }



        deliverySelect.addEventListener(
            "change",
            function(){


                state.sellingPlanId =
                    deliverySelect.value || null;


                console.log(
                    "Selected selling plan:",
                    state.sellingPlanId
                );


                const selectedPlan =
                    product.selling_plan_groups
                    ?.flatMap(group =>
                        group.selling_plans
                    )
                    .find(plan =>
                        String(plan.id) ===
                        String(state.sellingPlanId)
                    );


                const selectedVariant =
                    product.variants.find(
                        variant =>
                            variant.id == state.variantId
                    );


                if(
                    selectedPlan &&
                    selectedVariant
                ){

                    const subscriptionPrice =
                        getSubscriptionPrice(
                            selectedVariant,
                            selectedPlan
                        );


                    updatePrice(
                        priceElement,
                        {
                            price: subscriptionPrice
                        }
                    );

                }


            }
        );



        subscriptionBox.appendChild(
            deliverySelect
        );


    }



    sub_selector.appendChild(
        subscriptionBox
    );



    return wrapper;

}





function createPurchaseButton(
    text,
    sellingPlanId,
    state
){


    const button =
        document.createElement(
            "button"
        );


    button.type =
        "button";


    button.className =
        "wg-purchase-option";



    button.textContent =
        text;



    button.onclick =
        function(){



            state.sellingPlanId =
                sellingPlanId;



            button.parentElement
            .querySelectorAll(
                ".wg-purchase-option"
            )
            .forEach(btn=>{

                btn.classList.remove(
                    "active"
                );

            });



            button.classList.add(
                "active"
            );


        };



    return button;


}






/*
|--------------------------------------------------------------------------
| Price
|--------------------------------------------------------------------------
*/


function updatePrice(
    element,
    variant
){


    element.textContent =
        formatMoney(
            variant.price
        );


}






function formatMoney(cents){


    return new Intl.NumberFormat(
        "en-GB",
        {

            style:"currency",

            currency:"GBP"

        }
    )
    .format(
        cents / 100
    );


}






    /*
    |--------------------------------------------------------------------------
    | STATES
    |--------------------------------------------------------------------------
    */


    function showLoading(container){


        container.innerHTML = `

            <div class="wg-loading">

                Finding your routine...

            </div>

        `;


    }





    function showEmpty(container){


        container.innerHTML = `

            <div class="wg-empty">

                No recommendations found.

            </div>

        `;


    }






    function showError(container){


        container.innerHTML = `

            <div class="wg-error">

                Something went wrong.

                Please try again.

            </div>

        `;


    }

    /*
|--------------------------------------------------------------------------
| Quantity Selector
|--------------------------------------------------------------------------
*/

function createQuantitySelector(state){

    const wrapper =
        document.createElement("div");


    wrapper.className =
        "wg-quantity";


    const minus =
        document.createElement("button");


    minus.textContent =
        "-";


    const input =
        document.createElement("input");


    input.type =
        "number";

    input.min =
        1;

    input.value =
        state.quantity;



    const plus =
        document.createElement("button");


    plus.textContent =
        "+";



    minus.onclick = function(){

        if(state.quantity > 1){

            state.quantity--;

            input.value =
                state.quantity;

        }

    };



    plus.onclick = function(){

        state.quantity++;

        input.value =
            state.quantity;

    };



    input.onchange = function(){

        state.quantity =
            Math.max(
                1,
                parseInt(input.value || 1)
            );

    };



    wrapper.append(
        minus,
        input,
        plus
    );


    return wrapper;

}


/*
|--------------------------------------------------------------------------
| Add To Cart Button
|--------------------------------------------------------------------------
*/


function createAddToCartButton(state){


    const button =
        document.createElement("button");


    button.className =
        "wg-add-cart";


    button.textContent =
        "Add to Cart";



    button.onclick =
        async function(){


            button.disabled =
                true;


            button.textContent =
                "Adding...";



            try{


                await addToCart(
                    state
                );


                button.textContent =
                    "Added ✓";



                document.dispatchEvent(
                    new CustomEvent(
                        "wellgard:item-added",
                        {
                            detail:state
                        }
                    )
                );



                setTimeout(()=>{


                    button.disabled =
                        false;


                    button.textContent =
                        "Add to Cart";


                },1500);



            }
            catch(error){


                console.error(error);


                button.disabled =
                    false;


                button.textContent =
                    "Try Again";


            }


        };



    return button;

}
/*
|--------------------------------------------------------------------------
| Shopify Cart API
|--------------------------------------------------------------------------
*/


async function addToCart(state){


    const item = {


        id:
            state.variantId,


        quantity:
            state.quantity


    };



    if(state.sellingPlanId){

        item.selling_plan =
            state.sellingPlanId;

    }




    const response =
        await fetch(
            "/cart/add.js",
            {

                method:"POST",

                headers:{

                    "Content-Type":
                    "application/json"

                },

                body:
                JSON.stringify({

                    items:[
                        item
                    ]

                })

            }
        );



    if(!response.ok){

        throw new Error(
            "Add to cart failed"
        );

    }

  
    const data = await response.json();


    refreshCartDrawer();


    trackEvent(
        "add_to_cart",
        {
            product_id: state.productId,
            variant_id: state.variantId,
            selling_plan: state.sellingPlanId,
            quantity: state.quantity
        }
    );


    return data;

}

/*
|--------------------------------------------------------------------------
| Add All Products
|--------------------------------------------------------------------------
*/


window.Wellgard.addAllToCart =
async function(){


    const cards =
        document.querySelectorAll(
            ".wg-product-card"
        );



    const items = [];



    cards.forEach(card=>{


        const state =
            card.wellgardState;



        const item = {


            id:
                state.variantId,


            quantity:
                state.quantity


        };



        if(state.sellingPlanId){

            item.selling_plan =
                state.sellingPlanId;

        }



        items.push(item);


    });




    const response =
        await fetch(
            "/cart/add.js",
            {

                method:"POST",

                headers:{

                    "Content-Type":
                    "application/json"

                },

                body:
                JSON.stringify({

                    items

                })

            }
        );



    if(!response.ok){

        throw new Error(
            "Unable to add products"
        );

    }

    refreshCartDrawer();


    trackEvent(
        "add_all_to_cart",
        {
            products: items
        }
    );



    document.dispatchEvent(
        new CustomEvent(
            "wellgard:all-added"
        )
    );



    return response.json();


    };

    /*
    |--------------------------------------------------------------------------
    | Shopify Cart Refresh
    |--------------------------------------------------------------------------
    */

    function refreshCartDrawer(){

        /*
        Shopify themes use different events.
        We dispatch multiple common events.
        */

        document.dispatchEvent(
            new CustomEvent(
                "cart:refresh"
            )
        );


        document.dispatchEvent(
            new CustomEvent(
                "cart:updated"
            )
        );


        document.dispatchEvent(
            new CustomEvent(
                "cart-drawer:refresh"
            )
        );


    }

    /*
|--------------------------------------------------------------------------
| Analytics
|--------------------------------------------------------------------------
*/


function trackEvent(
    eventName,
    data={}
){


    console.log(
        "Wellgard Event:",
        eventName,
        data
    );


    /*
    GA4
    */

    if(
        typeof window.gtag === "function"
    ){

        window.gtag(
            "event",
            eventName,
            data
        );

    }



    /*
    Shopify Pixel compatibility
    */

    if(
        window.Shopify &&
        Shopify.analytics
    ){

        document.dispatchEvent(
            new CustomEvent(
                "wellgard:event",
                {
                    detail:{
                        event:eventName,
                        data:data
                    }
                }
            )
        );

    }


}

window.Wellgard.debugRenderer =
function(){

    console.log(
        "Cache",
        productCache
    );

};
function createRadioOption( text, type, state, priceElement, subscriptionBox,product){    
    const label = document.createElement("label");
    label.className ="wg-purchase-radio";
    label.innerHTML = `
    <input 
        type="radio"
        name="purchase-${state.productId}"
    >
    <span>${text}</span>
    `;

    const input = label.querySelector("input");
    if(!type){
        input.checked = true;
    }

    input.addEventListener(
        "change",
        () => {
            console.log(
                "Radio changed:",
                text,
                type
            );




            // Subscription selected
            if(type === "subscription") {

                const firstPlan = product.selling_plan_groups?.[0]?.selling_plans?.[0];
                if(firstPlan){
                    console.log("Selected subscription plan:",firstPlan);



                    const selectedVariant =
                        product.variants.find(
                            variant =>
                                variant.id == state.variantId
                        );


                    const subscriptionPrice =
                        getSubscriptionPrice(
                            selectedVariant,
                            firstPlan
                        );



                    updatePrice(
                        priceElement,
                        {
                            price: subscriptionPrice
                        }
                    );
                }
                state.sellingPlanId = firstPlan.id;





                

                if(subscriptionBox) {
                    subscriptionBox.style.display = "block";
                }
            }
            else {
                console.log("this is one time Purchase Selection");
                state.sellingPlanId = null;
                updatePrice(
                    priceElement,
                    product.variants.find(
                        variant =>
                            variant.id == state.variantId
                    )
                );


                subscriptionBox.style.display =   "none";

                const deliverySelect =
                    subscriptionBox?.querySelector(
                        ".wg-delivery-select"
                    );


                if(deliverySelect){

                    deliverySelect.value =
                        "";

                }

            }

        }
    );    



    return label;

}

function getSubscriptionPrice(
    variant,
    plan
){

    const basePrice =
        variant.price;


    if(
        !plan ||
        !plan.price_adjustments ||
        !plan.price_adjustments.length
    ){

        return basePrice;

    }


    const adjustment =
        plan.price_adjustments[0];


    if(
        adjustment.value_type === "percentage"
    ){

        return Math.round(
            basePrice -
            (
                basePrice *
                adjustment.value /
                100
            )
        );

    }


    return basePrice;

}


function refreshYotpoWithRetry(attempt = 0){

    const widgets =
        document.querySelectorAll(
            ".yotpo-widget-instance"
        );


    console.log(
        "Yotpo widgets found:",
        widgets.length,
        "attempt:",
        attempt
    );


    if(!widgets.length){
        return;
    }


    if(
        window.yotpoWidgetsContainer &&
        typeof window.yotpoWidgetsContainer.initWidgets === "function"
    ){

        console.log(
            "Starting Yotpo init"
        );


        window.yotpoWidgetsContainer.initWidgets();

          // Wait for Yotpo HTML injection
        setTimeout(()=>{

            customizeYotpoReviews();

        },500);





        return;

    }

   

    if(attempt < 10){

        setTimeout(()=>{

            refreshYotpoWithRetry(
                attempt + 1
            );



        },500);

    }

}

function customizeYotpoReviews(){
    console.log("this is testing .....");
    document
    .querySelectorAll(
        ".yotpo-sr-bottom-line-text"
    )
    .forEach(reviewText=>{

        reviewText.textContent =
            reviewText.textContent
            .replace(
                "Read",
                ""
            )
            .replace(
                "Verified",
                ""
            );

    });

}

// observeYotpo();


async function getCrossSellBenefit(productId){


    const query = `
    query {
        product(
            id:"gid://shopify/Product/${productId}"
        ){

            metafield(
                namespace:"custom",
                key:"cross_sell_benefit"
            ){
                value
            }

        }
    }
    `;


    const response =
        await fetch(
            `https://${window.WellgardStorefront.domain}/api/2025-07/graphql.json`,
            {
                method:"POST",

                headers:{
                    "Content-Type":"application/json",
                    "X-Shopify-Storefront-Access-Token":
                        window.WellgardStorefront.token
                },

                body:JSON.stringify({
                    query
                })
            }
        );


    const result =
        await response.json();


    return (
        result.data
        ?.product
        ?.metafield
        ?.value
        ||
        ""
    );

}

})();